import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Mosque = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 640 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M400 0c5 0 9.8 2.4 12.8 6.4 34.7 46.3 78.1 74.9 133.5 111.5 5.2 3.4 10.5 7 16 10.6 28.9 19.2 45.7 51.7 45.7 86.1 0 28.6-11.3 54.5-29.8 73.4H221.8c-18.4-19-29.8-44.9-29.8-73.4 0-34.4 16.7-66.9 45.7-86.1 5.4-3.6 10.8-7.1 16-10.6 55.4-36.6 98.8-65.2 133.5-111.5 3-4 7.8-6.4 12.8-6.4zM288 512v-72c0-13.3-10.7-24-24-24s-24 10.7-24 24v72h-48c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32h416c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32h-48v-72c0-13.3-10.7-24-24-24s-24 10.7-24 24v72h-64v-58c0-19-8.4-37-23-49.2L400 384l-25 20.8C360.4 417 352 435 352 454v58h-64zM70.4 5.2a15.9 15.9 0 0 1 19.2 0l16 12C139.8 42.9 160 83.2 160 126v2H0v-2C0 83.2 20.2 42.9 54.4 17.2l16-12zM0 160h160v136.6c-19.1 11.1-32 31.7-32 55.4v128c0 9.6 2.1 18.6 5.8 26.8-6.6 3.4-14 5.2-21.8 5.2H48c-26.5 0-48-21.5-48-48V160z"
  }));
});
Mosque.displayName = 'Mosque';
export var MosqueDimensions = {
  height: 512,
  width: 640
};